import React from 'react';
import {TableContext, TableContextValue} from '../Table/TableContext';

export interface TableHeadProps extends React.HTMLAttributes<HTMLTableSectionElement> {}

const contextValue: TableContextValue = {variant: 'head'};

/** @component */
export const TableHeadBase: React.FunctionComponent<TableHeadProps> = props => (
    <TableContext.Provider value={contextValue}>
        <thead {...props} />
    </TableContext.Provider>
);
